import { render, staticRenderFns } from "./traineePreassessmentList.vue?vue&type=template&id=5ed2f6b4&scoped=true"
import script from "./traineePreassessmentList.vue?vue&type=script&lang=js"
export * from "./traineePreassessmentList.vue?vue&type=script&lang=js"
import style0 from "./traineePreassessmentList.vue?vue&type=style&index=0&id=5ed2f6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2f6b4",
  null
  
)

export default component.exports